import { render, staticRenderFns } from "./softDownModule.vue?vue&type=template&id=70e795fb&scoped=true"
import script from "./softDownModule.vue?vue&type=script&lang=js"
export * from "./softDownModule.vue?vue&type=script&lang=js"
import style0 from "./softDownModule.vue?vue&type=style&index=0&id=70e795fb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70e795fb",
  null
  
)

export default component.exports